import $ from "jquery";
import {setCSRFheaders, generateRecaptchaToken, isEmail} from './es6/utils.js';
import {
	BUSINESS_IDENTIFIER_MINLEN,
	BUSINESS_IDENTIFIER_MAXLEN,
	BUSINESS_NAME_MINLEN,
	BUSINESS_NAME_MAXLEN
} from './es6/constants.js';
import {passwordStrengthChecker} from './es6/passwordStrengthChecker.js';
import {handleLogin} from './es6/preapp/handleLogin.js';
import {loadTranslationPage, trans} from './es6/i18next';
import { performSignup } from "./es6/signup/signupRequests"; 
import {newBusinessSelect} from './es6/signup/newBusinessSelect';
import { trackSignup } from "./es6/tracking.js";
import { addBackgroundToCookieBanner, setBingConsentGrantedOnOsanoBannerAccepted}  from './es6/utils'

async function main(){
    handleLogin();
	newBusinessSelect();
    try {
        let response = await loadTranslationPage('forgot_password_page');
    } catch(err){
        console.log('failed to fetch translations',  err);
    }
}

main();

$('body').on('keypress', '#desk.signup input', function(event){
	"use strict";
    if(event.keyCode == 13){
		event.preventDefault();

		if (!$(this).attr('data-block-enter')) {
		$(this).closest('.board').find('.proceed').click();
		}

		return false;
    }
});

$(document).ready(function() {
	setCSRFheaders();
	const anyPageWithPasswordStrElement = $("body").find("#passwordStr").length > 0;

	if (anyPageWithPasswordStrElement) {
		passwordStrengthChecker();
	}

	addBackgroundToCookieBanner();
	setBingConsentGrantedOnOsanoBannerAccepted();
});

$('body').on('keypress', '#desk.signup select', function(event){
	"use strict";
    if(event.keyCode == 13){
		event.preventDefault();
        //$(this).closest('.board').find('.proceed').click();
		return false;
    }
});

$('body').on('click', '#desk.signup [data-step-trigger]', function(event) {
	"use strict";
	event.preventDefault();

	if ($(this).attr('data-plan-id')) {
		$('[name="plan_id"]').val($(this).attr('data-plan-id'));
	}

	var existingSteps = $('[data-step]').length;
	var isForward;

	var direction = $(this).attr('data-step-trigger');

	var currentStep = parseFloat($(this).closest('.board').attr('data-step'));
	var goToStep;

	const captchaToken = $('[name="recaptcha_token"]').val();

	if (direction === 'back') {


	//goToStep = currentStep - 1;

	if ($('body').find('.board[data-step="' + parseInt(currentStep - 1) + '"]').length) {
	goToStep = currentStep - 1;
	} else {
	goToStep = currentStep - 2;
	}

	// remove all reactions
	showReaction(null, $(this), false, true);
	$('.loading').removeClass('loading');

	} else if (direction === 'forward') {

	if (!$(this).hasClass('back')) {
		$(this).addClass('loading');
	}

	//goToStep = currentStep + 1;

	if ($('body').find('.board[data-step="' + parseInt(currentStep + 1) + '"]').length) {
	goToStep = currentStep + 1;
	} else {
	goToStep = currentStep + 2;
	}

	isForward = true;
	}

    // EVR-11998: do skip subscription plan selection step

	/* if back go back and stop function */
	if (direction === 'back') {
		stepChange(goToStep);
		return false;
	}

	var error = false;
	removeErrors();

	switch(currentStep) {

		case 1:
		/* VALIDATE SIGN UP SECTION */
		var emailAddress = $('[name="email_address"]').val();
		var passwordOne = $('[name="password"]').val();
		var maxPasswordLength = 50;
        // Ensures the password contains at least one letter, one number, and one special character.
        var passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;"'`~<>,.?\\/-]).+$/

		if (!emailAddress || !isEmail(emailAddress)) {
			error = true;
			$('[name="email_address"]').addClass('error');
		}

		if (!passwordOne) {
			error = true;
			$('[name="password"]').addClass('error');
		} else {

                // Checks that the length is at least 8 characters after removing spaces.
                if (!passwordRegex.test(passwordOne) || passwordOne.replace(/ /g, '').length < 8) {
                $('.loading').removeClass('loading');
                error = true;
                $('[name="password"]').addClass('error');
                $('label[for="password"] span.error').html('Min 8 chars, 1 special, 1 letter, 1 number');
                return false;
			} else {
				$('[name="password"]').removeClass('error');
				$('label[for="password"] span.error').html('');
			}
		}

		// prevent insert of too long password
		if (passwordOne.length > maxPasswordLength) {
			error = true;
			$('[name="password"]').addClass('error');
			$('label[for="password"] span.error').html('Maximum 50 characters');
		}

		if (error === true) {

		/* error */
		$('.loading').removeClass('loading');
		showReaction('frown', $('[name="password"]'), false, false);
		return false;
		/* error */

		} else {

		var postArray = '{"email_address":"'+emailAddress+'", "token": "'+captchaToken+'"}';

		$.ajax({
			type: "POST",
			url: '/php/public_ajax_handler.php?type=check_apilayer_email_exists',
			data: ({ postArray: postArray }),
			dataType: "json",
			error: function(XMLHttpRequest, textStatus, errorThrown) {
     			alert(textStatus + ', ' + errorThrown);
				generateRecaptchaToken("preapp_check_apilayer_email_exists_error");
  			},
			success: function(data){

				if (data.success === 1) {

					if (data.message.email_exists === 1) {

					/* error */
					$('.loading').removeClass('loading');
					$('[name="email_address"]').addClass('error');
					$('label[for="email_address"] span.error').html('Email already exists');
					showReaction('frown', $('[name="password"]'), false, false);
					return false;
					/* error */

					} else {

					$('[name="email_address"]').removeClass('error');
					$('label[for="email_address"] span.error').html('');

					/* allow step change */
					stepChange(goToStep);

					}

				} else {
					/* error */
					$('.loading').removeClass('loading');
					showReaction('frown', $('[name="password"]'), false, false);
					alert(data.message);
					generateRecaptchaToken("preapp_check_apilayer_email_exists_success_false");
					return false;
					/* error */
				}

			}

		});
		}
		/* VALIDATE SIGN UP SECTION */
		break;

		case 2:
		/* VALIDATE ACCOUNT SECTION */
		$('.board.account [data-validate="required"]').each(function() {

			if (!$(this).val()) {
			error = true;
			$(this).addClass('error');
			} else {
			$(this).removeClass('error');
			}

		});

		if (error === true) {
		$('.loading').removeClass('loading');
		showReaction('frown', $('[data-validate="required"]'), false, false);
		return false;
		}

		/* allow step change */
		stepChange(goToStep);

		/* VALIDATE ACCOUNT SECTION */
		break;

		case 3:
		/* PLAN SECTION */
        if ($(this).data("planCode")) {
            $("input[name='plan_code']").val($(this).data("planCode"))
        }

		stepChange(goToStep);

		/* PLAN SECTION */
		break;

		case 4:
		/* VALIDATE BUSINESS SECTION */
		var subDomain = $('[name="vanity_url"]').val();
		var businessName = $('[name="business_name"]').val();
		var individual = false;

		if ($('[name="individual"]').prop('checked') === true) {
		individual = true;
		$('[name="business_name"]').removeClass('error');
		} else {

			if (!businessName) {
    		error = true;
			$('[name="business_name"]').addClass('error');
			} else {
                if (businessName.length < BUSINESS_NAME_MINLEN || businessName.length > BUSINESS_NAME_MAXLEN) {
                    error = true;
                    $('[name="business_name"]').addClass('error');
                    $('label[for="business_name"] span.error').html(`Between ${BUSINESS_NAME_MINLEN} and ${BUSINESS_NAME_MAXLEN} characters`);
				} else {
				    $('[name="business_name"]').removeClass('error');
				}

			}

		}

		if (!subDomain) {
            error = true;
            $('[name="vanity_url"]').addClass('error');
		} else {
			if(/^[a-zA-Z0-9]+$/.test(subDomain) == false) {
                error = true;
                $('[name="vanity_url"]').addClass('error');
                $('label[for="vanity_url"] span.error').html('No special characters allowed');
			} else {
                if (subDomain.length < BUSINESS_IDENTIFIER_MINLEN
                    || subDomain.length > BUSINESS_IDENTIFIER_MAXLEN)
                {
                    error = true;
                    $('[name="vanity_url"]').addClass('error');
                    $('label[for="vanity_url"] span.error').html(`Between ${BUSINESS_IDENTIFIER_MINLEN} and ${BUSINESS_IDENTIFIER_MAXLEN} characters`);
				}
			}
		}

		if (error === true) {
		$('.loading').removeClass('loading');
		showReaction('frown', $('[name="vanity_url"]'), false, false);
		return false;
		}

		var postArray = '{"identifier":"'+subDomain+'", "token": "'+captchaToken+'"}';

		$.ajax({
			type: "POST",
			url: '/php/public_ajax_handler.php?type=check_business_id_exists',
			data: ({ postArray: postArray }),
			dataType: "json",
			error: function(XMLHttpRequest, textStatus, errorThrown) {
     			alert(textStatus + ', ' + errorThrown);
  			},
			success: function(data){

				if (data.success === 1) {

					if (data.message.identifier_exists === 1) {

					/* error */
					$('.loading').removeClass('loading');
					$('[name="vanity_url"]').addClass('error');
					$('label[for="vanity_url"] span.error').html('Domain already exists');
					showReaction('frown', $('[name="vanity_url"]'), false, false);
					return false;
					/* error */

					} else {

					/* allow sign up */
					$('.loading').removeClass('loading');

					// show redirecting... since this process may take a few secs
					generalInfo('show', 'success', 'Redirecting ...');

                    trackSignup('main_signup');

					showReaction('smile', $('[name="vanity_url"]'), true, false);


                // Disable the button and apply CSS changes
                var button = $('button.finish_signup[data-cy="signup-submit-last-step-btn"]');

                if (button.length > 0) {
                    button.prop('disabled', true)
                        .css({
                            'cursor': 'not-allowed',
                            'opacity': '0.5'
                        });
                } 

					performSignup();
					return false;

					}

				} else {
				/* error */
				$('.loading').removeClass('loading');
				showReaction('frown', $('[name="vanity_url"]'), false, false);
				alert(data.message);
				return false;
				/* error */
				}

			}

		});
		/* VALIDATE BUSINESS SECTION */
		break;

	}


});

function stepChange(destinationStep) {
	"use strict";

	$('[data-step-target]').removeClass('current');
	
    $('[data-step]').hide();
	$('[data-step="'+destinationStep+'"]').fadeIn();

	if (destinationStep === 3) { /* if step 3 stay on "Account" Step */

		if ($('[name="plan_predefined"]').val() == '1') {
		// unless plan has been predefined
		$('[data-step-target="'+destinationStep+'"]').addClass('current');
		} else {
		$('[data-step-target="2"]').addClass('current');
		}

        // EVR-11998: do skip subscription plan selection step
	} else {
	$('[data-step-target="'+destinationStep+'"]').addClass('current');
	}
}

function removeErrors() {
	"use strict";

	$('label span.error').html('');
	$('label').removeClass('error');
	$('input').removeClass('error');

}


$('body').on('change', '[name="individual"]', function() {
	"use strict";

	$('[name="business_name"]').val('');

	if ($(this).prop('checked') === true) {
	$('[name="business_name"]').addClass('disabled');
	$('[name="business_name"]').attr('disabled', 'disabled');
	} else {
	$('[name="business_name"]').removeAttr('disabled');
	$('[name="business_name"]').removeClass('disabled');
	}

});

var smile = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.6 18.6"><g><path d="M9.3 18.6C4.2 18.6 0 14.5 0 9.3 0 4.2 4.2 0 9.3 0c5.1 0 9.3 4.2 9.3 9.3 0 5.2-4.1 9.3-9.3 9.3zm0-17.1C5 1.5 1.5 5 1.5 9.3s3.5 7.8 7.8 7.8 7.8-3.5 7.8-7.8-3.5-7.8-7.8-7.8z"></path><ellipse cx="6.9" cy="6.8" rx="1.2" ry="1.6"></ellipse><ellipse cx="11.7" cy="6.8" rx="1.2" ry="1.6"></ellipse><path d="M9.3 14.2c-1.9 0-3.7-1.1-4.4-2.9-.2-.4 0-.8.4-1 .4-.2.8 0 1 .4.5 1.2 1.7 2 3.1 2 1.3 0 2.5-.8 3.1-2 .2-.4.6-.5 1-.4.4.2.6.6.4 1-.9 1.7-2.7 2.9-4.6 2.9z"></path></g></svg>';

var frown = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.6 18.6"><g><path d="M9.3 18.6C4.2 18.6 0 14.5 0 9.3 0 4.2 4.2 0 9.3 0c5.1 0 9.3 4.2 9.3 9.3 0 5.2-4.1 9.3-9.3 9.3zm0-17.1C5 1.5 1.5 5 1.5 9.3s3.5 7.8 7.8 7.8 7.8-3.5 7.8-7.8-3.5-7.8-7.8-7.8z"></path><ellipse cx="6.9" cy="6.8" rx="1.2" ry="1.6"></ellipse><ellipse cx="11.7" cy="6.8" rx="1.2" ry="1.6"></ellipse><path d="M12.9 13.8c-.3 0-.5-.1-.7-.4-.6-1.1-1.7-1.7-2.9-1.7s-2.3.7-2.9 1.7c-.2.4-.7.5-1 .3-.4-.2-.5-.7-.3-1 .9-1.5 2.5-2.5 4.2-2.5 1.7 0 3.4 1 4.2 2.5.2.4.1.8-.3 1-.1.1-.2.1-.3.1z"></path></g></svg>';

function showReaction(smileOrFrown, thisContainer, keepReaction, removeReaction) {
    "use strict";

    if (removeReaction === true) {
        $(thisContainer).closest('.board').find('[data-reaction="true"] .reaction').hide();
        $(thisContainer).closest('.board').find('[data-reaction="true"]').not('.skip_for_now').css('background', '#ff6633');
        $(thisContainer).closest('.board').find('[data-reaction="true"] .reaction').html('');
        $(thisContainer).closest('.board').find('[data-reaction="true"] .default').fadeIn();
    }

    var reaction;
    var reactionColor;

    if (smileOrFrown === 'smile') {
        reaction = smile;
        reactionColor = '#3da07b';
    } else {
        reaction = frown;
        reactionColor = '#e35256';
    }

    $(thisContainer).closest('.board').find('[data-reaction="true"] .default').hide();
    $(thisContainer).closest('.board').find('[data-reaction="true"]').css('background', reactionColor);
    $(thisContainer).closest('.board').find('[data-reaction="true"] .reaction').html(reaction);
    $(thisContainer).closest('.board').find('[data-reaction="true"] .reaction').fadeIn();

    if (keepReaction !== true) {
        setTimeout(function () {
            var defaultBackgroundColour;

            if ($('[name="product_name"]').val() === 'invoicely') {
                defaultBackgroundColour = '#ff6633';
            } else if ($('[name="product_name"]').val() === 'eversign') {
                if ($('body').hasClass('api_signup')) {
                    defaultBackgroundColour = '#3da07b';
                } else {
                    defaultBackgroundColour = '#df7055';
                }
            } else {
                defaultBackgroundColour = '#000000';
            }

            $(thisContainer).closest('.board').find('[data-reaction="true"] .reaction').hide();
            $(thisContainer).closest('.board').find('[data-reaction="true"]').css('background', defaultBackgroundColour);
            $(thisContainer).closest('.board').find('[data-reaction="true"] .reaction').html('');
            $(thisContainer).closest('.board').find('[data-reaction="true"] .default').fadeIn();
        }, 1000);
    }
}


function dateWithMonthsOffset(months) {
	if (months) {
		const date = new Date();
		date.setMonth(date.getMonth() + months);
		return date;
	}
}

function setTACcookie () {
	// since our login cookie lives 2 months, make sure GA cookie lives longer
	const cookieExpiryDate = dateWithMonthsOffset(3);
	document.cookie = 'eversign_cookie_policy=1; expires=' + cookieExpiryDate + '; SameSite=Lax';
}

/* SELECT BUSINESS - SWITCH BETWEEN BUSINESS LIST AND ADD BUSINESS */
$('body').on('click', '#desk.select_business .switch_select_business', function(event) {
	"use strict";
	event.preventDefault();

	if ($(this).hasClass('add')) {
	$(this).closest('.board').hide();
	$('.board.signup.business').fadeIn();
	} else {
	$(this).closest('.board').hide();
	$('.board.select_business').fadeIn();
	}

});

/* SELECT BUSINESS - SUBMIT ADD BUSINESS FORM */
$('body').on('click', '#desk.select_business button.submit_add_business', function(event) {
	"use strict";
	event.preventDefault();

		var error = false;
		removeErrors();

		$(this).addClass('loading');

		var subDomain = $('[name="vanity_url"]').val();
		var businessName = $('[name="business_name"]').val();
		var individual = false;
		const captchaToken = $('[name="recaptcha_token"]').val();

		if ($('[name="individual"]').prop('checked') === true) {
		individual = true;
		$('[name="business_name"]').removeClass('error');
		} else {

			if (!businessName) {
                error = true;
                $('[name="business_name"]').addClass('error');
			} else {
                if (businessName.length < BUSINESS_NAME_MINLEN
                    || businessName.length > BUSINESS_NAME_MAXLEN)
                {
                    error = true;
                    $('[name="business_name"]').addClass('error');
                    $('label[for="business_name"] span.error').html('Between ' +
                        BUSINESS_NAME_MINLEN + ' and ' +
                        BUSINESS_NAME_MAXLEN + ' characters');
				} else {
				    $('[name="business_name"]').removeClass('error');
				}
			}
		}

		if (!subDomain) {
            error = true;
            $('[name="vanity_url"]').addClass('error');
		} else {
			if(/^[a-zA-Z0-9]+$/.test(subDomain) == false) {
                error = true;
                $('[name="vanity_url"]').addClass('error');
                $('label[for="vanity_url"] span.error').html('No special characters allowed');
			} else {
                if (subDomain.length < BUSINESS_IDENTIFIER_MINLEN
                    || subDomain.length > BUSINESS_IDENTIFIER_MAXLEN)
                {
                    error = true;
                    $('[name="vanity_url"]').addClass('error');
                    $('label[for="vanity_url"] span.error').html('Between ' +
                        BUSINESS_IDENTIFIER_MINLEN + ' and ' +
                        BUSINESS_IDENTIFIER_MAXLEN + ' characters');
				}
			}
		}

		if (error === true) {
		$('.loading').removeClass('loading');
		showReaction('frown', $('[name="vanity_url"]'), false, false);
		return false;
		}

	var	postData = {
		business_name: businessName,
		business_vanity_name: subDomain,
		no_business: $('[name="individual"]').prop('checked') == true ? 1 : 0,
		token: captchaToken
	};

	var postDataJSON = JSON.stringify(postData);
	//console.log(postDataJSON);

	$.ajax({
		type: "POST",
		url: '/php/advanced_ajax_handler.php?type=add_business',
		data: ({ postArray: postDataJSON }),
		dataType: "json",
		error: function(XMLHttpRequest, textStatus, errorThrown) {
     		alert(textStatus + ', ' + errorThrown);
			 generateRecaptchaToken("preapp_add_business_error");
  		},
		success: function(data){

			if (data.success === 1) {

				$('.loading').removeClass('loading');
				showReaction('smile', $('[name="vanity_url"]'), true, false);

                // Disable the button and apply CSS changes
                var button = $('button.finish_signup[data-cy="signup-submit-last-step-btn"]');

                if (button.length > 0) {
                    button.prop('disabled', true)
                        .css({
                            'cursor': 'not-allowed',
                            'opacity': '0.5'
                        });
                } 

				window.location.href = 'https://'+data.message.base_url+'/dashboard';
				return false;

			}  else {

				$('.loading').removeClass('loading');
				showReaction('frown', $('[name="vanity_url"]'), false, false);
				generalInfo('show', 'error', data.message);
				generateRecaptchaToken("preapp_add_business_success_false");
				return false;

			}

		}

	});


});


/* GENERAL PANEL ERROR INFO SUCCESS MESSAGE */
function generalInfo(showHide, type, message) {
    "use strict";

	if (showHide === 'hide') {

	$('.alert.dynamic').remove();

	} else if (showHide && type && message) {

	$('aside#alerts').html('<p class="alert '+type+' dynamic">'+message+'</p>');

	}

}


/* CHANGE PRIMARY BUSINESS */
$('body').on('click', 'li:not(.primary) [data-action="change_primary_business"]', function() {

	var that = $(this);

	// disallow re-change
	$('body').find('.star').css('pointer-events', 'none');
	const captchaToken = $('[name="recaptcha_token"]').val();

	var	postData = {
		business_id: $(this).attr('data-business-id'),
		token: captchaToken
	};

	var postDataJSON = JSON.stringify(postData);
	//console.log(postDataJSON);

	$.ajax({
		type: "POST",
		url: '/php/advanced_ajax_handler.php?type=switch_primary_business',
		data: ({ postArray: postDataJSON }),
		dataType: "json",
		error: function(XMLHttpRequest, textStatus, errorThrown) {
     		alert(textStatus + ', ' + errorThrown);
			generateRecaptchaToken("preapp_switch_primary_business_error");
  		},
		success: function(data){

			// allow re-change
			$('body').find('.star').css('pointer-events', 'initial');

			if (data.success === 1) {

				$('body').find('.board.select_business ul li').removeClass('primary');
				that.closest('li').addClass('primary');

				generalInfo('show', 'success', 'Primary Business changed.');

			} else {

				generalInfo('show', 'error', data.message);
				generateRecaptchaToken("preapp_switch_primary_business_success_false");
			}

		}

	});

});


/* EVERSIGN TEAM MEMBER SIGNUP */
$('body').on('submit', '[name="team_signup"]', function(event) {

	event.preventDefault();

	var emailInput = $(this).find('[name="team_signup[email_address]"]');
	var firstNameInput = $(this).find('[name="team_signup[first_name]"]');
	var lastNameInput = $(this).find('[name="team_signup[last_name]"]');
	var passwordInput = $(this).find('[name="team_signup[password]"]');

    const promotionalEmailCheckbox = document.getElementById(
        'promotional_emails_consent',
    )
    const hasPromotionalEmailConsent =
        promotionalEmailCheckbox && promotionalEmailCheckbox.checked

    const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;"'`~<>,.?\\/-]).+$/


	var error = false;

	const captchaToken = $('[name="recaptcha_token"]').val();

	if(!firstNameInput.val()) {
		firstNameInput.addClass('error');
		error = true;
	} else {
		firstNameInput.removeClass('error');
	}

	if(!lastNameInput.val()) {
		lastNameInput.addClass('error');
		error = true;
	} else {
		lastNameInput.removeClass('error');
	}

	if (!passwordInput.val()) {

		error = true;
		passwordInput.addClass('error');

	} else {

        if (passwordInput.val().length <= 8 || !passwordRegex.test(passwordInput.val())) {
            passwordInput.closest('.form_row').find('span.error').html('Min 8 chars, 1 letter, 1 number, 1 special');
            passwordInput.addClass('error');
            } else {
            passwordInput.closest('.form_row').find('span.error').html('');
            passwordInput.removeClass('error');
            }

	}

	if (!isEmail(emailInput.val())) {
		error = true;
		emailInput.addClass('error');
	} else {
		emailInput.removeClass('error');
	}

	if (error === true) {
	return false;
	}

	var button = $(this).find('[data-loading="true"]');

	button.addClass('loading');

	// build POST array
	var postData = {
		business_id: $(this).find('[name="business_id"]').val(),
		plan_id: 47, // free plan
		first_name: firstNameInput.val(),
		last_name: lastNameInput.val(),
		email_address: emailInput.val(),
		password: passwordInput.val(),
		tos_accepted: 1,
		team_signup: 1,
		mapper_hash: $(this).find('[name="mapper_hash"]').val(),
		token: captchaToken,
		promotional_emails_consent: hasPromotionalEmailConsent
	};

	var postDataJSON = JSON.stringify(postData);

	$.ajax({
		type: "POST",
		url: '/php/public_ajax_handler.php?type=create_account',
		data: ({ postArray: postDataJSON }),
		dataType: "json",
		error: function(XMLHttpRequest, textStatus, errorThrown) {
     		//alert(textStatus + ', ' + errorThrown);
			generateRecaptchaToken("preapp_create_account_error");
  		},
		success: function(data){

			if (data.success === 1) {

				generalInfo('show', 'success', 'Redirecting ...');

                // Disable the button and apply CSS changes
                var button = $('button[form="team_signup"].proceed');

                if (button.length > 0) {
                    button.prop('disabled', true)
                        .css({
                            'cursor': 'not-allowed',
                            'opacity': '0.5'
                        });
                } 

                trackSignup('team_signup');

				var baseURL = data.message.base_url;

				var redirectTo = 'https://eversign.com/perform_login?email_address='+encodeURIComponent(emailInput.val())+'&one_time_signin_key='+data.message.one_time_signin_key;

				window.location.href = redirectTo;
				return false;

			} else {

				console.log('error:', data.message);
				generateRecaptchaToken("preapp_create_account_success_false");
			}

			button.removeClass('loading');

		}

	});
});
